class ProductGoalMeter extends HTMLElement {
    constructor() {
        super();
    }

    static GOAL_ITEMS = 3;

    static classProgress1 = 'progress-30';
    static classProgress2 = 'progress-60';
    static classProgress3 = 'progress-100';

    connectedCallback() {
        this.progressBar = this.querySelector('[data-product-progress]');
        this.messageElement = this.querySelector('[data-product-message]');
        this.progressMeter = this.querySelector('[data-product-progress-meter]');
        this.textElement = this.querySelector('.text');

        this.initialize();
        this.bindCartEvents();
    }

    bindCartEvents() {
        // Shopify não dispara evento padrão → interceptamos mudanças
        document.addEventListener('cart:refresh', () => this.initialize());
        document.addEventListener('ajaxProduct:added', () => this.initialize());

        // fallback (caso tema não tenha eventos)
        document.addEventListener('change', () => this.initialize());
    }

    initialize() {
        if (typeof Shopify === 'undefined' || !Shopify.getCart) return;

        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    normalizeText(text) {
        return text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    isBone(title) {
        const normalized = this.normalizeText(title);
        return normalized.includes('bone');
    }

    countBones(cart) {
        let count = 0;

        cart.items.forEach(item => {
            if (this.isBone(item.product_title)) {
                count += item.quantity;
            }
        });

        return count;
    }

    calculateProgress(cart) {
        const totalBones = this.countBones(cart);

        let progress = Math.round((totalBones * 100) / ProductGoalMeter.GOAL_ITEMS);
        if (progress > 100) progress = 100;

        const text = this.getText(totalBones);
        const classLabel = this.getClassLabel(progress);

        this.setProgress(progress, text, classLabel);
    }

    getText(totalBones) {
        this.messageElement.classList.remove('messageWin');
        if (totalBones === 0) {
            this.progressBar.classList.add('progress-hidden');
            return `<span>Adicione ${ProductGoalMeter.GOAL_ITEMS} bonés e ganhe 1 grátis!</span>`;
        }

        this.progressBar.classList.remove('progress-hidden');

        if (totalBones >= ProductGoalMeter.GOAL_ITEMS) {
            this.messageElement.classList.add('messageWin');
            return `<span>🎉 Você ganhou um boné grátis!</span>`;
        }

        const remaining = ProductGoalMeter.GOAL_ITEMS - totalBones;

        return `<span>Adicione mais ${remaining} boné${remaining > 1 ? 's' : ''} totalmente grátis!</span>`;
    }

    getClassLabel(progress) {
        if (progress === 0) return 'none';
        if (progress <= 30) return ProductGoalMeter.classProgress1;
        if (progress <= 60) return ProductGoalMeter.classProgress2;
        return ProductGoalMeter.classProgress3;
    }

    resetProgressClass(classLabel) {
        this.progressBar.classList.remove(
            'progress-30',
            'progress-60',
            'progress-100',
            'progress-free'
        );

        this.progressBar.classList.add(classLabel);
    }

    setProgress(progress, text, classLabel) {
        this.resetProgressClass(classLabel);

        this.progressMeter.style.width = `${progress}%`;

        if (this.textElement) {
            this.textElement.innerHTML = `${progress}%`;
        }

        this.messageElement.innerHTML = text;
    }
}

// 🔥 EVITA ERRO DE DUPLICAÇÃO
if (!customElements.get('product-goal-component')) {
    customElements.define('product-goal-component', ProductGoalMeter);
}